module.exports = __webpack_public_path__ + "static/media/home-category-2.283c0826.png";